<script>
    import moment from 'moment';
    import {imask} from 'svelte-imask';
    import {api, api_getcourse, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import ImageCDN from '../components/ImageCDN.svelte';
    import LoadingCard from '../components/LoadingCard.svelte';
    import {Link} from 'svelte-routing';
    
    const user = store('credentials', 'appUserAuth');
    
    export let id = '';

    const loadEvent = async () => {
        let result = await api('getEvent', {idEvent: id, emailEventMember: ($user.email ? $user.email : '')});
        
        if (result.data && result.data.nameProd) {
            stars = result.data.rating ? result.data.rating : 0;
            review = result.data.otziv ? result.data.otziv : '';
            
            return result.data;
        }
    
        throw new Error();
    };

    let fetchEvent = loadEvent();

    // принять участие...
    const handlerTakePart = async () => {
        let popup = new bootstrap.Modal(document.getElementById('member-add'));
        let data = await fetchEvent;
    
        let callback = async () => {
            await api('saveToEventMembers', {
                idEvent: data.id,
                idRegPred: data.idRegPred,
                email: ($user.email ? $user.email : ''),
                actualnost: 1,
            });
            fetchEvent = await loadEvent();
    
            let fd = new FormData;
                fd.append('email', ($user.email ? $user.email : ''));
                fd.append('name', ($user.name ? $user.name : ''));
                fd.append('title', data.nameProd);
                fd.append('date', data.datePlan);
                fd.append('address', data.adres);
                fd.append('city', data.gorod);
                fd.append('password', pasport);
    
            await fetch(location.origin + '/form/registraciya-na-meropriyatii', {
                method: 'POST',
                body: fd
            });
    
            popup.show();
            setTimeout(() => popup.hide(), 2500);
        };
        
        await (parseFloat(data.price) > 0 ? pay(callback) : callback());
    }

    // регистрация
    let lastname = '',
        firstname = '',
        surname = '',
        tel = '',
        email = '',
        pasport = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6),
        readterms = true,
        code = '',
        code_confirm = '',
        code_options = {mask: '000-000-000'};

    // popup
    let popup;
    
    const handlerConfirm = async () => {
        code = [
            getRandomInt(100, 999),
            getRandomInt(100, 999),
            getRandomInt(100, 999)
        ].join('-')
        
        if (tel && email && pasport && readterms) {
            popup = new bootstrap.Modal(document.getElementById('member-confirm'));
            
            let fd = new FormData;
                fd.append('email', email);
                fd.append('code', code);
            
            await fetch(location.origin + '/form/podtverzhdenie-registracii-uchastnika', {
                method: 'POST',
                body: fd
            });
    
            popup.show();
        }
    };
    
    const handlerRegister = async () => {
        let data = await fetchEvent;
    
        popup.hide();
        
        if (code === code_confirm && readterms) {
            if (email && pasport) {
                popup = new bootstrap.Modal(document.getElementById('member-register'));
    
                // регистрация пользователя
                await api('addEventMembers', {
                    idRegPred: data.idRegPred,
                    name: [lastname, firstname, surname].join(' ').trim(),
                    gorod: data.gorod,
                    tel: tel,
                    email: email,
                    pasport: pasport,
                });
    
                // регистрация в getcourse
                await api_getcourse('user/register', {
                    email: email,
                    phone: tel,
                    first_name: firstname,
                    last_name: lastname,
                    city: data.gorod,
                    partner: data.emailRegPred,
                });
                
                await user.load({login: email, password: pasport});
    
                let fd = new FormData;
                    fd.append('email', email);
                    fd.append('password', pasport);
    
                await fetch(location.origin + '/form/uspeshnaya-registraciya', {
                    method: 'POST',
                    body: fd
                });
    
                popup.show();
                setTimeout(() => popup.hide(), 2500);
            }
        } else {
            setTimeout(() => popup.show(), 700);
        }
    };
    
    // оплата
    const pay = async (callback) => {
        let data = await fetchEvent;
        let widget = new window.cp.CloudPayments();
        let orderId = [$user.id, id].join('-');
    
        widget.pay('charge',
            {
                publicId: 'pk_a061857895fdcb409ed05d3bee757',
                description: 'Оплата участия в мероприятии "' + data.nameProd + '"',
                amount: parseFloat(data.price),
                currency: 'RUB',
                accountId: $user.email ? $user.email : email,
                invoiceId: orderId,
                email: $user.email ? $user.email : email,
                skin: 'mini',
            },
            {
                onComplete: async (paymentResult, options) => {
                    if (paymentResult.success) {
                        if (callback) {
                            await callback();
                            await api('payEventMember', {
                                idEvent: id,
                                idOrder: options.invoiceId,
                                summaPay: options.amount,
                                email: options.email,
                            });
                        }
                    }
                }
            }
        )
    };

    // рейтинг
    let review = '', stars = 0;
    const handlerSaveReview = async () => {
        let popup = new bootstrap.Modal(document.getElementById('member-review'));
        let data = await fetchEvent;
    
        await api('saveReview', {
            idEvent: data.id,
            email: ($user.email ? $user.email : ''),
            otziv: review,
            rating: stars,
        });
        
        popup.show();
        setTimeout(() => popup.hide(), 2500);
    };
</script>

<TopMenu title="Мероприятие">
    <TopMenu_BackBtn slot="back" href="/events" />
</TopMenu>

<div id="appCapsule">
    {#await fetchEvent}
        <LoadingCard />
    {:then data}
        <div class="section mt-3 mb-3" style="user-select: none;">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                    <div class="card">
                        {#if data.otherScan}
                            <ImageCDN src="{data.otherScan}" class="card-img-top" alt="{data.nameProd}" style="height: 300px; width:100%; object-fit: cover;" />
                        {/if}
    
                        <div class="card-body">
                            <h2 class="title text-md-center m-0">{data.nameProd}</h2>
                            
                            {#if data.imember === '1'}
                                <div class="alert alert-outline-success fade show mt-2 text-center" role="alert">
                                    Вы участник мероприятия!
                                </div>
                            {/if}
                        </div>
    
                        {#if $user.id}
                            {#if data.imember === '1'}
                                <div class="card-footer">
                                    <Link to="/events/view/{id}/tests" class="btn btn-outline-secondary btn-block btn-lg">Материалы</Link>
                                </div>
                            {:else if data.mest - data.members > 0}
                                <div class="card-footer">
                                    <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerTakePart}>
                                        {#if +data.price > 0}Оплатить участие{:else}Зарегистрироваться на мероприятие{/if}
                                    </button>
    
                                    <p class="text-center mt-2">
                                        Нажимая на кнопку “{#if +data.price > 0}Оплатить участие{:else}Зарегистрироваться на мероприятие{/if}”, вы даете
                                        <a href="https://drive.google.com/file/d/1Cg_FDcQGKEvbbrRht_IKNbDgCmjxli3T/view?usp=sharing" target="_blank">согласие</a><br>
                                        на обработку своих персональных данных<br>
                                        в соответствии с <a href="https://drive.google.com/file/d/18KDnuoR0sp1e5EHVZ8Kp1-V8Pu2oEDkk/view?usp=sharing" target="_blank">Политикой обработки персональных данных</a>.
                                    </p>
                                </div>
                            {/if}
                        {:else}
                            <div class="card-footer">
                                <div class="row">
                                    <div class="col-8">
                                        <button type="button" class="btn btn-primary btn-block btn-lg" data-bs-toggle="modal" data-bs-target="#registerMember">
                                            Зарегистрироваться
                                        </button>
                                    </div>
                                    <div class="col-4">
                                        <Link to="/?ev={id}" class="btn btn-outline-primary btn-block btn-lg">
                                            Войти
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
    
                    {#if data.name}
                        <div class="card mt-2">
                            <div class="card-header">Описание</div>
                            <div class="card-body">
                                <p class="card-text m-0">{@html data.name}</p>
                            </div>
                        </div>
                    {/if}
                    {#if data.datePlan && data.timePlan}
                        <div class="card mt-2">
                            <div class="card-header">Дата и время проведения</div>
                            <div class="card-body">
                                <p class="card-text m-0">{moment(data.datePlan).format('DD.MM.YYYY')} {data.timePlan}</p>
                            </div>
                        </div>
                    {/if}
                    {#if (+data.price)}
                        <div class="card mt-2">
                            <div class="card-header">Стоимость</div>
                            <div class="card-body">
                                <p class="card-text m-0">
                                    {#if (+data.summaOpl)}
                                        Оплачено {moment(data.dateOpl).format('DD.MM.YYYY')}, сумма {(+data.summaOpl).toFixed(2)}
                                    {:else}
                                        {((+data.price).toFixed(2))}
                                    {/if}
                                </p>
                            </div>
                        </div>
                    {/if}
                    {#if data.adres}
                        <div class="card mt-2">
                            <div class="card-header">Адрес</div>
                            <div class="card-body">
                                <p class="card-text m-0">{data.adres}</p>
                            </div>
                        </div>
                    {/if}
                    {#if data.mest}
                        <div class="card mt-2">
                            <div class="card-header">Места участников</div>
                            <div class="card-body">
                                {#if data.mest && data.mest - data.members < data.mest * 0.25 && !data.imember}
                                    <div class="alert alert-outline-danger fade show mb-3" role="alert">
                                        <h4 class="alert-title">Осталось мало мест!</h4>
                                        Поторопитесь зарегистрироваться на участие.
                                    </div>
                                {/if}
                                
                                <p class="card-text">
                                    Всего <u>{data.mest}</u> мест{#if !data.imember}, из них доступно <u>{data.mest - data.members}</u> мест{/if}
                                </p>
                            </div>
                        </div>
                    {/if}
                    {#if data.komment}
                        <div class="card mt-2">
                            <div class="card-header">Комментарий</div>
                            <div class="card-body"><p class="card-text">{data.komment}</p></div>
                        </div>
                    {/if}
                    {#if data.imember && data.start && data.start.toString() === '1'}
                        <div class="card mt-2">
                            <div class="card-header">Ваша оценка</div>
                            <div class="card-body">
                                <p>Мы хотим повышать качество мероприятий и нам необходим Ваш отзыв. </p>
    
                                <div class="row">
                                    <div class="col-12 text-center">
                                        {#each {length: 5} as _, i}
                                            <button type="button" class="btn btn-icon mx-1 btn-outline-primary" on:click={() => {stars = i + 1}}>
                                                <i class="{i < stars ? 'fas' : 'far'} fa-star fa-2x"></i>
                                            </button>
                                        {/each}
                                    </div>
    
                                    <div class="col-12">
                                        <div class="form-group boxed">
                                            <div class="input-wrapper">
                                                <label for="review">Комментарий</label>
                                                <textarea name="review" id="review" class="form-control" style="min-height:70px" bind:value={review}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="button" class="btn btn-outline-primary btn-block" on:click={handlerSaveReview}>Сохранить</button>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    
        {#if $user.id}
            <div class="modal fade dialogbox" id="member-add" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-icon text-success">
                            <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title">Вы участвуете в мероприятии</h5>
                        </div>
                        <div class="modal-footer">
                            <div class="btn-inline">
                                <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="modal fade dialogbox" id="member-review" data-bs-backdrop="static" tabindex="-1">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-icon text-success">
                            <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title">Отзыв сохранён!</h5>
                        </div>
                        <div class="modal-body">
                            Спасибо!
                        </div>
                        <div class="modal-footer">
                            <div class="btn-inline">
                                <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <!-- Form Add Member Sheet -->
            <div class="modal fade modalbox" id="registerMember" data-bs-backdrop="static" tabindex="-1" aria-modal="true" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Регистрация участника</h5>
                            <a href="#" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                        <div class="modal-body">
                            <div class="login-form">
                                <div class="section mb-5">
                                    <form>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="lastname">Фамилия</label>
                                                <input type="text" class="form-control" id="lastname" name="lastname" placeholder="Иванченко" autocomplete="off" bind:value={lastname}>
                                            </div>
                                        </div>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="firstname">Имя</label>
                                                <input type="text" class="form-control" id="firstname" name="firstname" placeholder="Наталья" autocomplete="off" bind:value={firstname}>
                                            </div>
                                        </div>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="surname">Отчество</label>
                                                <input type="text" class="form-control" id="surname" name="surname" placeholder="Николаевна" autocomplete="off" bind:value={surname}>
                                            </div>
                                        </div>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="tel">Телефон <span class="text-danger">*</span></label>
                                                <input type="tel" class="form-control" id="tel" name="tel" autocomplete="off" bind:value={tel} required>
                                            </div>
                                        </div>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="email">E-Mail <span class="text-danger">*</span></label>
                                                <input type="email" class="form-control" id="email" name="email" autocomplete="off" bind:value={email} required>
                                                <span class="text-muted text-small">На указанный адрес будет выслан код подтверждения</span>
                                            </div>
                                        </div>
                                        <div class="form-group basic">
                                            <div class="input-wrapper">
                                                <label class="form-label" for="email">Пароль <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="password" name="password" autocomplete="off" bind:value={pasport} required>
                                                <span class="text-muted text-small">Запишите пароль или укажите свой</span>
                                            </div>
                                        </div>
        
                                        <div class="row my-2">
                                            <div class="col-12">
                                                <div class="d-flex justify-content-start justify-content-md-center align-items-center">
                                                    <div class="form-check form-switch col-2" style="margin-right: 10px;">
                                                        <input class="form-check-input" type="checkbox" id="getcourse" readonly disabled checked>
                                                        <label class="form-check-label" for="getcourse"></label>
                                                    </div>
                                                    <div class="col" style="text-align: justify;">
                                                        Зарегистрироваться в <a href="https://dietolognata.ru/" target="_blank">dietolognata.ru</a>.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row my-2">
                                            <div class="col-12">
                                                <div class="d-flex justify-content-start justify-content-md-center align-items-center">
                                                    <div class="form-check form-switch col-2" style="margin-right: 10px;">
                                                        <input class="form-check-input" type="checkbox" id="readterms" bind:checked={readterms}>
                                                        <label class="form-check-label" for="readterms"></label>
                                                    </div>
                                                    <div class="col" style="text-align: justify;">
                                                        Подтверждаю, что ознакомлен(а) и согласен(на) с положениями
                                                        <a href="https://drive.google.com/file/d/17HDbBxFzUrUz_g4NKy56VndFZxmbGftP/view?usp=sharing" target="_blank">публичной оферты</a>.<br>
                                                        Настоящим я даю
                                                        <a href="https://drive.google.com/file/d/17HDbBxFzUrUz_g4NKy56VndFZxmbGftP/view?usp=sharing" target="_blank">согласие</a>
                                                        на получение электронных сообщений рекламного характера.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="form-group basic">
                                            <button type="button" class="btn btn-primary btn-block" data-bs-dismiss="{readterms ? 'modal' : ''}" on:click={handlerConfirm}>
                                                Продолжить
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- * Form Add Member Sheet -->
    
            <div class="modal fade dialogbox" id="member-confirm" data-bs-backdrop="static" tabindex="-1" >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Подтвердите регистрацию</h5>
                        </div>
                        <div class="modal-body  mb-2">
                            Для завершения процесса регистрации, пожалуйста, введите код подтверждения, который был
                            отправлен на указанный вами адрес электронной почты.
                        </div>
                        <form>
                            <div class="modal-body text-start mb-2">
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="form-label" for="code">Код подтверждения</label>
                                        <input type="text" class="form-control text-center" id="code" placeholder="000-000-000" use:imask={code_options} bind:value={code_confirm}>
                                        <i class="clear-input">
                                            <ion-icon name="close-circle" role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                                        </i>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="btn-inline">
                                    <button type="button" class="btn btn-text-primary" on:click={handlerRegister}>Подтвердить</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        
            <div class="modal fade dialogbox" id="member-register" data-bs-backdrop="static" tabindex="-1">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-icon text-success">
                            <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title">Добро пожаловать!</h5>
                        </div>
                        <div class="modal-body">
                            Вы успешно зарегистрировались!
                        </div>
                        <div class="modal-footer">
                            <div class="btn-inline">
                                <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    {:catch error}
        <LoadingCard />
    {/await}
</div>
